module.exports = __webpack_public_path__ + "static/media/WeiLuo.d3bde872.jpg";